import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import * as React from 'react';

interface IChipListWrapper {
  children?: React.ReactNode;
  emptyPlaceholder?: string;
}

function ChipListWrapper({ children = null, emptyPlaceholder = '' }: IChipListWrapper) {
  return (
    <Stack direction={{ sm: 'row', xs: 'column' }} spacing={1} sx={{ alignItems: 'flex-start', pb: 1 }}>
      {children ? (
        <Grid container>{children}</Grid>
      ) : (
        <Box sx={{ alignItems: 'center', display: 'block' }}>
          <Typography color="text.secondary" component="span" sx={{ fontWeight: 'medium' }} variant="body2">
            {emptyPlaceholder}
          </Typography>
        </Box>
      )}
    </Stack>
  );
}

export default ChipListWrapper;
